var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:[{'is-current-page': _vm.link.is_current_page}, 'nav__a'],attrs:{"id":_vm.link.id,"role":"menuitem","href":_vm.link.url}},[_vm._v("\n  "+_vm._s(_vm.link.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }